const LeadGate = {

    config: {
        formId: "Yvp5wa",
        storageKey: "leadgate",
        version: 1,
        successDelay: 600,
        fadeDuration: 300
    },

    gate: null,

    init() {

        this.gate = document.getElementById("lead-gate");

        if (!this.gate) return;

        // Head script already decided gate isn't needed
        if (!document.documentElement.classList.contains("lead-gate-required")) {

            this.destroy(true);

            return;

        }

        this.lockScroll();

        requestAnimationFrame(() => {
            this.gate.classList.add("active");
            document.documentElement.classList.remove("lead-gate-loading");
        });

        this.bindKlaviyo();

    },

    bindKlaviyo() {

        window.addEventListener("klaviyoForms", (event) => {

            const detail = event.detail;

            if (!detail) return;

            if (detail.type !== "submit") return;

            if (detail.formId !== this.config.formId) return;

            this.onSuccess();

        });

    },

    onSuccess() {

        this.saveState();

        setTimeout(() => {

            this.unlock();

        }, this.config.successDelay);

    },

    saveState() {

        const state = {
            unlocked: true,
            version: this.config.version,
            timestamp: Date.now()
        };

        localStorage.setItem(
            this.config.storageKey,
            JSON.stringify(state)
        );

    },

    unlock() {

        this.gate.classList.add("closing");

        setTimeout(() => {

            this.destroy(false);

        }, this.config.fadeDuration);

    },

    destroy(skipAnimation = false) {

        document.documentElement.classList.remove("lead-gate-lock");
        document.body.classList.remove("lead-gate-lock");
        document.documentElement.classList.remove("lead-gate-required");

        if (!this.gate) return;

        this.gate.remove();

    },

    lockScroll() {

        document.documentElement.classList.add("lead-gate-lock");
        document.body.classList.add("lead-gate-lock");

    }

};

document.addEventListener("DOMContentLoaded", () => {

    LeadGate.init();

});